<template>
    <div id="cooperation">
        <div class="item" v-for="item in detail" :key="item.id">
            <div class="left">
                <img :src="$imgBaseURL+item.url" alt="">
            </div>
            <div class="right">
                <p class="name">{{item.title}}</p>
                <p class="desc">{{item.body}}</p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Cooperation",
        data(){
            return{
                detail:[]
            }
        },
        methods:{
            getNav(){
                this.$axios({
                    url:'/navigation/navigationbar',
                    method:'get'
                }).then(res=>{
                    if (res.data.code === 200){
                        this.detail = JSON.parse(res.data.msg.navigationBars[1].navigationSubmenus[3].content);
                        
                    }
                })
            },
        },
        created() {
            this.getNav();
        }
    }
</script>

<style scoped lang="less">
#cooperation{
    margin-top: 30px;
    .item{
        margin-bottom: 20px;
        padding: 20px;
        border: 1px solid #D8D8D8;
        border-radius: 10px;
        display: flex;
        .left{
            margin-right: 20px;
            img{
                width: 330px;
                height: 165px;
            }
        }
        .right{
            flex: 1;
            .name{
                color: #181818;
                font-size: 16px;
                line-height: 32px;
                font-weight: bold;
            }
            .desc{
                color: #777777;
                font-size: 14px;
                line-height: 24px;
                margin-top: 6px;
            }
        }
    }
}
</style>
